module.exports = __webpack_public_path__ + "static/sport/main-register.7151a7d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/main-register.gif
// module id = WBJp
// module chunks = 0